<template>
  <div v-if="conseillerAffiche">
    <div
      class="d-flex align-center flex-column titre-h4 --text-grey-dark pb-4 px-8 px-md-0"
    >
      <div class="align-self-center secondary--text">
        Pour cela, contactez votre conseiller {{ isDteAffiche ? 'DTE' : '' }} :
      </div>
    </div>
    <v-card
      :class="$vuetify.breakpoint.mobile ? '' : 'pa-2 min-width'"
      elevation="10"
    >
      <div
        v-if="conseillerAffiche"
        class="d-flex align-center flex-column pt-2"
      >
        <div class="align-self-center titre-h2 secondary--text py-2">
          {{ conseillerAffiche.nom }}
        </div>
        <div class="align-self-center intro py-1">
          {{ conseillerAffiche.email }}
        </div>
        <div
          v-if="conseillerAffiche.numTel"
          class="align-self-center intro py-1"
        >
          {{ formatNumeroTelephone(conseillerAffiche.numTel) }}
        </div>
      </div>
      <div
        v-if="!(isAbonneCulturial && (codeFeature==='COMPARATEUR_MARGE' || codeFeature==='BILAN_ANNUEL' || codeFeature==='PRIX_EQUILIBRE_CULTURE' || codeFeature==='PREVISIONNEL'))"
        class="d-flex justify-center secondary--text py-5 px-3"
      >
        <v-tooltip
          v-if="$roles.isUtilisateurAgrial() && !$roles.hasAllWriteAccess()"
          bottom
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <AgrButton
                class="px-8 pt-1"
                large
                disabled
                @click="onDemandeInfos"
              >
                <span class="action white--text pb-1">Demander à être recontacté(e)</span>
              </AgrButton>
            </div>
          </template>
          Vous n'avez pas les autorisations
        </v-tooltip>
        <AgrButton
          v-else
          :disabled="loading.createDemandeInfosAbonnement || hasDemandeRecente"
          :loading="loading.createDemandeInfosAbonnement"
          large
          :block="!$vuetify.breakpoint.mobile"
          @click="onDemandeInfos"
        >
          <span class="action white--text pb-1">
            Demander à être recontacté(e)
          </span>
        </AgrButton>
      </div>
    </v-card>
  </div>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import {formatNumeroTelephone} from '@/utils/string'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'ContactConseiller',
  components: {AgrButton},
  props: {
    codeFeature: {
      type: String,
      required: true,
    },
    isConseillerPvAffiche: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      loading: {
        init: false,
        createDemandeInfosAbonnement: false
      },
      erreur: {
        init: false,
        createDemandeInfosAbonnement: false
      }
    }
  },

  computed: {
    ...mapGetters({
      hasDemandeRecente: 'demandeInfosAbonnement/hasDemandeRecente',
      conseillers: 'adherent/tousConseillers',
      abonnements: 'adherent/abonnements'
    }),
    
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },

    conseillerAffiche () {
      if (this.isAbonneCulturial && (this.codeFeature==='COMPARATEUR_MARGE' || this.codeFeature==='BILAN_ANNUEL' || this.codeFeature==='PRIX_EQUILIBRE_CULTURE' || this.codeFeature==='PREVISIONNEL') && this.conseillerDte && !this.isConseillerPvAffiche) {
        return this.conseillerDte
      } else {
        return this.conseillerPV ? this.conseillerPV : this.conseillerMixte
      }
    },

    conseillerPV () {
      const conseillersPV = this.conseillers.filter(conseiller => !!conseiller.fonctions.CE)
      return conseillersPV.length ? conseillersPV[0]: null
    },

    conseillerMixte () {
      const conseillersMixte = this.conseillers.filter(conseiller => !!conseiller.fonctions.MI)
      return conseillersMixte.length ? conseillersMixte[0]: null
    },
    conseillerDte () {
      const conseillersDte = this.conseillers.filter(conseiller => !!conseiller.fonctions.EE)
      return conseillersDte.length ? conseillersDte[0]: null
    },
    isDteAffiche () {
      return (this.conseillerAffiche!= null && this.conseillerDte!= null) ? this.conseillerAffiche.codeConseille === this.conseillerDte.codeConseille : false
    }
  },

  created () {
    this.loading.init = true
    this.erreur.init = false

    Promise.all([
      this.getHasDemandeRecente(),
      this.getTousConseillers()
    ])
      .catch(() => this.erreur.init = true)
      .finally(() => this.loading.init = false)
  },

  methods: {
    ...mapActions({
      createDemandeInformationAbonnement: 'demandeInfosAbonnement/createDemandeInformationAbonnement',
      getHasDemandeRecente: 'demandeInfosAbonnement/getHasDemandeRecente',
      getTousConseillers: 'adherent/getTousConseillers',
    }),

    formatNumeroTelephone,
    onDemandeInfos () {
      this.loading.createDemandeInfosAbonnement = true
      this.erreur.createDemandeInfosAbonnement = false

      this.createDemandeInformationAbonnement(this.codeFeature)
        .catch(() => this.erreur.createDemandeInfosAbonnement = true)
        .finally(() => this.loading.createDemandeInfosAbonnement = false)
    }
  }
}
</script>
<style lang="scss" scoped>
.min-width {
  min-width: 450px;
}
</style>

